import nl from './translations/nl';
import en from './translations/en';
var text = {
    en: en,
    nl: nl,
};
export default text;
